module.exports = __webpack_public_path__ + "static/media/click3.a27916a0.ogg";